"use client"
import {
  DatePicker
} from "./chunk-5TQUTEMZ.mjs";

// src/components/multi-date-picker.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var MultiDatePicker = mergeMultiStyle(DatePicker)();

export {
  MultiDatePicker
};
//# sourceMappingURL=chunk-MVIO7L4D.mjs.map